<template>
  <div class="landing-page-outer">
    <div class="landing-page-inner">
      <h1>Bacon Playoff Pickem</h1>
      <template v-if="loading">
        <p>Attempting to Log in... </p>
      </template>
      <template v-if="!loading">
        <template v-if="isLoggedIn">
          <p>Welcome back, {{loggedInUser.preferredDisplayName}} ({{loggedInUser.email}})</p>
        </template>
        <template v-else>
          <p>Sign in to join a league or make your selections</p>
        </template>
      </template>
      <v-divider />
      <div v-if="myLeagues && myLeagues.length > 0">
        <h2 class="mt-2">My Leagues</h2>
        <ul>
          <li class="my-2" v-for="league in myLeagues" :key="league.id">
            <router-link :to="{name: routes.LEAGUE, params: {leagueId: league.id}}">
              <v-btn class="ml-2">View</v-btn>
            </router-link> - {{league.name}}
          </li>
        </ul>
      </div>

      <div class="mt-10">
        <h2 class="mt-2">Leagues</h2>
        <ul>
          <li class="my-2" v-for="league in otherLeagues" :key="league.id">
            <router-link :to="{name: routes.LEAGUE, params: {leagueId: league.id}}">
              <v-btn class="ml-2">View</v-btn>
            </router-link> - {{league.name}}
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import * as routes from '@/router/route-names'
import {computed, ComputedRef, onMounted, ref, type Ref} from 'vue'
import { HttpClient } from '@/components/httpclient/http-client'
import {useStore} from '@/store/store'
import {League, ShowLeaguesResp} from '@/types/league-types'
import {AxiosResponse} from 'axios'

const store = useStore()

onMounted(async () => {
  await showLeagues()
  loading.value = false
})

const loading = ref(true)
const leagues : Ref<League[]> = ref([])

const isLoggedIn = computed(()=> store.getters.isLoggedIn)
const loggedInUser = computed(()=> store.getters.getLoggedInUser)
const getUserLeagueIds :ComputedRef<string[]> = computed(()=> store.getters.getUserLeagueIds)

const myLeagues = computed(() => {
  const myLeagues : League[] = []
  leagues.value.forEach(l => {
    if (getUserLeagueIds.value.includes(l.id)) {
      myLeagues.push(l)
    }
  })
  return myLeagues
})

const otherLeagues = computed(() => {
  const myLeagues : League[] = []
  leagues.value.forEach(l => {
    if (!getUserLeagueIds.value.includes(l.id)) {
      myLeagues.push(l)
    }
  })
  return myLeagues
})

const showLeagues = async () => {
  try {
    const response :AxiosResponse<ShowLeaguesResp> = await HttpClient.get('/oapi/leagues')
    if (response.data && response.data.leagues){
      leagues.value = response.data.leagues
    }
  } catch (ex) {
    console.error(ex)
  }
}


</script>
<style scoped lang="scss">
.landing-page-inner {
  max-width: 800px;
  margin: 0 auto
}
.landing-page-outer {
  max-width: 90%;
  margin: 0 auto
}
</style>
